// src/pages/CrearCasa.js
import React, { useState } from 'react';
import { db } from '../firebase';
import { collection, addDoc } from 'firebase/firestore';
import { useAuth } from '../context/AuthContext';
import { registerMovement } from '../utils/registerMovement';
// Usaremos los estilos de un formulario que ya tenemos
import '../components/CrearAviso.css'; 

const CrearCasa = () => {
    const { userData, currentUser } = useAuth();
    const [numeroCasa, setNumeroCasa] = useState('');
    const [nombreResidente, setNombreResidente] = useState('');
    const [feedback, setFeedback] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        const fraccionamientoId = userData?.fraccionamientoId;

        if (!fraccionamientoId) {
            setFeedback("Error: No se pudo identificar el fraccionamiento.");
            return;
        }
        if (!numeroCasa.trim() || !nombreResidente.trim()) {
            setFeedback("Por favor, completa todos los campos.");
            return;
        }

        try {
            // Apuntamos directamente a la subcolección de casas
            const casasRef = collection(db, 'fraccionamientos', fraccionamientoId, 'casas');
            const docRef = await addDoc(casasRef, {
                numero: numeroCasa,
                nombre_residente: nombreResidente,
                disponible: true, // Valores por defecto
                moroso: true,
                fechaUltimoPago: null,
                // Añade otros campos con valores por defecto si lo deseas
            });

            setFeedback(`¡Casa ${numeroCasa} creada con éxito en el fraccionamiento ${fraccionamientoId}!`);
            setNumeroCasa('');
            setNombreResidente('');

            try {
                await registerMovement({
                    fraccionamientoId,
                    titulo: `Nueva casa registrada: ${numeroCasa}`,
                    descripcion: `Residente: ${nombreResidente}`,
                    categoria: 'Catálogo',
                    tipoMovimiento: 'casa_creada',
                    origen: 'viviendas',
                    metadata: {
                        casaId: docRef.id,
                        casaNumero: numeroCasa,
                        nombreResidente,
                    },
                    userData,
                    currentUser,
                });
            } catch (logError) {
                console.error('CrearCasa: error al registrar movimiento', logError);
            }

        } catch (error) {
            console.error("Error al crear la casa:", error);
            setFeedback("Hubo un error al crear la casa.");
        }
    };

    return (
        <div className="crear-aviso-container">
            <h2>Crear Nueva Casa Manualmente</h2>
            <form onSubmit={handleSubmit} className="crear-aviso-form">
                <div className="form-group">
                    <label htmlFor="numeroCasa">Número de Casa</label>
                    <input
                        type="text"
                        id="numeroCasa"
                        value={numeroCasa}
                        onChange={(e) => setNumeroCasa(e.target.value)}
                        placeholder="Ej: 101, 20-A, etc."
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="nombreResidente">Nombre del Residente</label>
                    <input
                        type="text"
                        id="nombreResidente"
                        value={nombreResidente}
                        onChange={(e) => setNombreResidente(e.target.value)}
                        placeholder="Nombre completo"
                    />
                </div>
                <button type="submit" className="btn-publicar">Crear Casa</button>
            </form>
            {feedback && <p className="mensaje-feedback">{feedback}</p>}
        </div>
    );
};

export default CrearCasa;